import { render, staticRenderFns } from "./DeleteBusinessUnit.vue?vue&type=template&id=5ebce446&scoped=true&"
import script from "./DeleteBusinessUnit.vue?vue&type=script&lang=js&"
export * from "./DeleteBusinessUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebce446",
  null
  
)

export default component.exports